import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  HStack,
} from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiFileExcel2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { openCreateExamDataModel } from "../../../modules/admin-modules/models/Actions";
import { addBulkCorrectionRequest } from "../../../modules/admin-modules/exams/Actions";

const C = {
  primary: "#6A1E1E",
  secondary: "#4A0F1F",
  border: "#D8CEC3",
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({ setAdd, setSelectedData, searchTerm, setSearchTerm }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.exams.count);

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            Exams
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            Create exams, publish results, and manage access and retakes.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            Total exams: {count ?? 0}
          </Text>
        </Box>

        <HStack spacing={3} flexWrap="wrap" justify="flex-end">
          <Button
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            leftIcon={<RiFileExcel2Line />}
            color={C.secondary}
            bg="rgba(255,255,255,0.85)"
            fontWeight="800"
            position="relative"
            px={5}
            py={6}
            _hover={{ bg: "rgba(233, 226, 219, 0.5)" }}
          >
            Bulk marks (Excel)
            <Input
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (!file) return;
                const formData = new FormData();
                formData.append("marks_bulk", file);
                dispatch(addBulkCorrectionRequest(formData));
                e.target.value = "";
              }}
              type="file"
              accept=".xlsx,.xls,.csv"
              opacity="0"
              position="absolute"
              w="100%"
              h="100%"
              left={0}
              top={0}
              cursor="pointer"
            />
          </Button>
          <Button
            borderRadius="full"
            leftIcon={<RiAddFill />}
            bg={C.primary}
            color="#FAF2EB"
            px={8}
            py={6}
            fontWeight="800"
            _hover={{ bg: C.secondary }}
            onClick={() => {
              setSelectedData({});
              setAdd(true);
              dispatch(openCreateExamDataModel());
            }}
          >
            Add exam
          </Button>
        </HStack>
      </Flex>

      <Box mb={6} maxW="520px">
        <Input
          placeholder="Search exams by name…"
          value={searchTerm}
          borderRadius="full"
          border="1px solid"
          borderColor={C.border}
          bg="rgba(255,255,255,0.85)"
          px={4}
          _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(106, 30, 30, 0.2)" }}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Box>
    </Box>
  );
};

export default SearchBar;
